import React, { FC, PropsWithChildren } from 'react';

import styles from './CheckIconInCircle.module.scss';

export const CheckIconInCircleWrapper = ({ children }: PropsWithChildren) => (
    <div className={styles.checkIconInCircleWrapper}>
        {children}
    </div>
);

export interface ICheckIconCircleProps extends ICheckIconInCircleProps {}

export const CheckIconCircle = ({ checkIconCircleColor }: ICheckIconCircleProps) => {

    return (
        <div className={styles.checkIconCircle} style={{ '--check-icon-circle-color': checkIconCircleColor } as React.CSSProperties}></div>
    );
};

export interface ICheckIconProps extends ICheckIconInCircleProps {}

export const CheckIcon = ({ checkIconColor }: ICheckIconProps) => {

    return (
            <svg className={styles.checkIcon} width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.1536 2.10855L6.12437 10.1375C5.88349 10.3784 5.56729 10.4996 5.25109 10.4996C4.93489 10.4996 4.61869 10.3784 4.3778 10.1375L0.363319 6.12303C-0.119804 5.64014 -0.119804 4.85936 0.363319 4.37646C0.846215 3.89334 1.62677 3.89334 2.10989 4.37646L5.25109 7.51766L12.407 0.361976C12.8899 -0.121147 13.6705 -0.121147 14.1536 0.361976C14.6365 0.844872 14.6365 1.62542 14.1536 2.10855Z" fill={checkIconColor} />
            </svg>
    );
};

interface ICheckIconInCircleProps {
    checkIconCircleColor?: string;
    checkIconColor?: string;
}

export const CheckIconInCircle: FC<ICheckIconInCircleProps> = ({
                                                                   checkIconCircleColor = '#FFDDBC',
                                                                   checkIconColor = '#EB731A',
                                                                           }) => {

    return (
        <CheckIconInCircleWrapper>
            <CheckIconCircle checkIconCircleColor={checkIconCircleColor} />
            <CheckIcon checkIconColor={checkIconColor} />
        </CheckIconInCircleWrapper>
    );
};
